import { render } from "./LootCrateButton.vue?vue&type=template&id=0bd920d8"
import script from "./LootCrateButton.vue?vue&type=script&lang=js"
export * from "./LootCrateButton.vue?vue&type=script&lang=js"

import "./LootCrateButton.vue?vue&type=style&index=0&id=0bd920d8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__